export function setFlexBasis() {
    var menuItems = document.querySelectorAll('.menu-item');

    menuItems.forEach(function(item) {
        // Get all classes of the element
        var classes = item.className.split(' ');
        // Filter the classes to find the one starting with 'is-width-'
        var widthClass = classes.find(function(className) {
            return className.startsWith('is-width-');
        });

        if (widthClass) {
            // Extract the width value from the class name
            var widthValue = parseInt(widthClass.replace('is-width-', ''));
            // Set the flex-basis style of the element
            item.style.flexBasis = widthValue + '%';
        }
    });
}